import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'humanize'
})
export class HumanizePipe implements PipeTransform {

  transform(value: string, ...args: unknown[]): unknown {
    return new HumanizableString(value).toHumanString();
  }

}



export class HumanizableString extends String {
    capitalizeFirstLetter() {
      const transformed = this.charAt(0).toUpperCase() + this.slice(1);
      return new HumanizableString(transformed);
    };

    camelCaseToSpaces()  {
      const camelMatch = /([A-Z])/g;
      return new HumanizableString(this.replace(camelMatch, " $1"));
    };

    removeId() {
        const camelMatch = /_id/g;
        return new HumanizableString(this.replace(camelMatch, ""));
    };

    underscoresToSpaces() {
      const camelMatch = /_/g;
      return new HumanizableString(this.replace(camelMatch, " "));
    };

    toLower(): HumanizableString {
        return new HumanizableString(this.toLowerCase());
    }

    //   humanize(lower_case_and_underscored_word) public
    //   Capitalizes the first word
    //  and turns underscores into spaces and strips a trailing
    // "_id", if any. Like titleize, this is meant for creating pretty output.
    //   Examples:
    //     "employee_salary" # => "Employee salary"
    //     "author_id"       # => "Author"
    toHumanString() {
      return this
        .camelCaseToSpaces()
        .toLower()
        .removeId()
        .underscoresToSpaces()
        .capitalizeFirstLetter()
        .toString();
    };
}
